import baseAxiosAuthGateway from './config/baseAxiosAuthGateway';
import baseAxiosAuthServicos from './config/baseAxiosAuthServicos';

async function getCertificadoDetalhes(produto, sequencia) {
  return baseAxiosAuthGateway.get(`/gb-api/v1/associados/certificados/${produto}/${sequencia}`, {
    responseType: 'blob',
  });
}

async function getExtratos() {
  return baseAxiosAuthServicos.get('/v1/planos/extratos');
}

async function getExtratoDetalhes(produto, sequencia) {
  return baseAxiosAuthGateway.get(`/gb-api/v1/associados/extratos/${produto}/${sequencia}`, {
    responseType: 'blob',
  });
}

async function getPlanos() {
  return baseAxiosAuthServicos.get('/v1/planos');
}

async function getPlanoDetalhes(produto, sequencia) {
  return baseAxiosAuthServicos
    .get(`/v1/planos/${produto}/${sequencia}`)
    .then(({ data }) => data);
}

async function getDetalhesAlteracaoFormaPagamento(sequencia) {
  return baseAxiosAuthServicos
    .get(`/v1/planos/${sequencia}/alteracao-forma-pagamento`);
}

export {
  getCertificadoDetalhes,
  getExtratos,
  getExtratoDetalhes,
  getDetalhesAlteracaoFormaPagamento,
  getPlanos,
  getPlanoDetalhes
};